import { render } from "./TicketsModal.vue?vue&type=template&id=535e9b00&scoped=true&lang=pug"
import script from "./TicketsModal.vue?vue&type=script&lang=ts"
export * from "./TicketsModal.vue?vue&type=script&lang=ts"

import "./TicketsModal.vue?vue&type=style&index=0&id=535e9b00&lang=scss"
import "./TicketsModal.vue?vue&type=style&index=1&id=535e9b00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-535e9b00"

export default script